import React, { ReactNode, useContext } from 'react'
import { LOADER_ENUM } from '../../models/LoaderModel';
import ComponentLoader from '../../commonfields/ComponentLoader';
import { MainContext } from '../../models/MainContext';

const LoaderHOC = (component: ReactNode, field: LOADER_ENUM) => {
  const { loadersList } = useContext(MainContext)

  return (
    <>
      { loadersList?.includes(field) ? <ComponentLoader /> : component} 
    </>
  )
}

export default LoaderHOC;